"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CellMember = void 0;
const react_1 = __importDefault(require("react"));
const styled_1 = require("./styled");
const utils_1 = require("./utils");
const CellMember = (props) => {
    const { members, className, style, cellClassName, cellStyle } = props;
    if (!members) {
        return null;
    }
    const renderMember = (member) => (react_1.default.createElement(styled_1.CellMemberStyled, { className: cellClassName, style: cellStyle, key: member.id },
        member.avatar ? react_1.default.createElement(styled_1.AvatarStyled, { avatar: member.avatar }) : (react_1.default.createElement(styled_1.AvatarStyled, { bg: (0, utils_1.getAvatarRandomColor)(member.id) }, (0, utils_1.getFirstWordFromString)(member.name.trim()).toUpperCase())),
        react_1.default.createElement(styled_1.NameStyled, null, member.name)));
    return (react_1.default.createElement(styled_1.CellMemberWrapperStyled, { className: className, style: style }, Array.isArray(members) ? members.map(renderMember) : renderMember(members)));
};
exports.CellMember = CellMember;
